import {define, singleton} from '@injex/core';
import EntityRequestAdapter from '../../../stdlib/EntityRequestAdapter';
import IWidget from '../interfaces/IWidget';

@define()
@singleton()
export class WidgetsAPI extends EntityRequestAdapter<IWidget> {
    protected basePathName: string = 'widgets';
}